import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const CoverImageSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  height: auto;
  background-color: ${p => (p.bgC ? p.bgC : "#f2sdec3")};
  .container {
    width: 100%;
  }
  .img {
    width: 100%;
  }

  @media screen and (max-width: 526px) {
    .first {
      display: none;
    }
  }
`
const CoverImage: React.FC<{}> = function () {
  const { allContentfulFolioLaunch } = useStaticQuery(graphql`
    query FolioLaunchPics {
      allContentfulFolioLaunch {
        edges {
          node {
            backgroundColor
            id
            # secondImage {
            #   localFile {
            #     childImageSharp {
            #       fluid(maxWidth: 2000) {
            #         ...GatsbyImageSharpFluid_tracedSVG
            #       }
            #     }
            #   }
            # }
            firstImage {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 2000) {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const firstNode = allContentfulFolioLaunch.edges[0].node
  return (
    <CoverImageSection bgC={firstNode.backgroundColor}>
      <div className="container first">
        <Img
          fluid={firstNode.firstImage.localFile.childImageSharp.fluid}
          className="img"
        />
      </div>

      {/* <div className="container">
        <Img
          fluid={firstNode.secondImage.localFile.childImageSharp.fluid}
          className="img"
        />
      </div> */}
    </CoverImageSection>
  )
}

export default CoverImage
